/**
 * Generated by orval v6.15.0 🍺
 * Do not edit manually.
 * SMP Backend API (Admin)
 * The SMP backend API description
 * OpenAPI spec version: 1.0
 */
import { customAxios } from '../lib/axios';

import type {
  UserDto,
  CreateUpdateUserRequest,
  ResourceDto,
  ResourcesControllerFindAllV1Params,
  CreateUpdateResourceRequest,
  ResourceFilterOptions,
  AddLanguagesRequest,
  SetLocationsRequest,
  LocationDto,
  ResourceDocumentDto,
  CreateResourceDocumentDto,
  ResourceBatchRequest,
  LanguageDto,
  LanguagesControllerFindAllV1Params,
  CreateUpdateLanguageRequest,
  CreateUpdateLocationRequest,
  ServiceBookingDto,
  CreateServiceBookingRequest,
  ServiceBookingGroupDto,
  ServiceBookingsControllerFindAllV1Params,
  UpdateServiceBookingRequest,
  UpsertVerificationRequest,
  UpdateSurchargeRequest,
  TransformBookingRequest,
  ResourceJobDto,
  ResourceServiceBookingDto,
  ResourceBookingsControllerFindBookingsV1Params,
  CloseBookingRequest,
  SurchargeDto,
  ResourceBillableDto,
  ResourceBookingsControllerGetBillableBookingsV1Params,
  ResourceBookingsControllerGetBillableBookingsExportV1Params,
  UpdateCancellationFeeDto,
  CustomerDto,
  RegisterCustomerRequest,
  CustomersControllerFindAllWithPaginationV1200,
  CustomersControllerFindAllWithPaginationV1Params,
  UpdateCustomerRequest,
  CustomersControllerFindCustomerBookingsV1200,
  CustomersControllerFindCustomerBookingsV1Params,
  CustomersControllerDownloadCustomerBookingsV1Params,
  AddBlockedResourceRequest,
  SettingsDto,
  UpsertServiceRateReqeuest,
  CreateUpdateDateTimeSurchargeDto,
  CreateUpdateExpressSurchargeDto,
  CreateUpdateTravelSurchargeDto,
  UpsertOpeningHoursRequest,
  LexofficeEvent,
  InvoiceDto,
  InvoiceControllerGetInvoicesV1Params,
  CreatInvoiceRequest,
  ChargeableServiceBookingsDto,
  InvoiceControllerGetChargeableServiceBookingsByCustomerV1Params,
  SendServiceBookingSummaryMailRequest,
  CustomerRequestsReportDto,
  ReportsControllerGetRequestReportV1Params,
  BookingStatusCountsResponseDto,
  ReportsControllerGetBookingReportV1Params,
  ReportsControllerGetBookingReportExcelV1Params,
  HereAutocompleteResponse,
  HereControllerAutocompleteV1Params,
} from './dtos';

export const getSMPBackendAPIAdmin = () => {
  const usersControllerFindMeV1 = () => {
    return customAxios<UserDto>({ url: `/api/v1/users/me`, method: 'get' });
  };

  const usersControllerUpdateMeV1 = (createUpdateUserRequest: CreateUpdateUserRequest) => {
    return customAxios<void>({
      url: `/api/v1/users/me`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateUserRequest,
    });
  };

  const usersControllerFindOneV1 = (id: string) => {
    return customAxios<UserDto>({ url: `/api/v1/users/${id}`, method: 'get' });
  };

  const usersControllerDeleteV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/users/${id}`, method: 'delete' });
  };

  const usersControllerUpdateV1 = (
    id: string,
    createUpdateUserRequest: CreateUpdateUserRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/users/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateUserRequest,
    });
  };

  const usersControllerFindAllV1 = () => {
    return customAxios<UserDto[]>({ url: `/api/v1/users`, method: 'get' });
  };

  const usersControllerCreateV1 = (createUpdateUserRequest: CreateUpdateUserRequest) => {
    return customAxios<UserDto>({
      url: `/api/v1/users`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateUserRequest,
    });
  };

  const resourcesControllerFindAllV1 = (params?: ResourcesControllerFindAllV1Params) => {
    return customAxios<ResourceDto[]>({ url: `/api/v1/resources`, method: 'get', params });
  };

  const resourcesControllerCreateV1 = (
    createUpdateResourceRequest: CreateUpdateResourceRequest
  ) => {
    return customAxios<ResourceDto>({
      url: `/api/v1/resources`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateResourceRequest,
    });
  };

  const resourcesControllerGetFilterOptionsV1 = () => {
    return customAxios<ResourceFilterOptions>({
      url: `/api/v1/resources/filter-options`,
      method: 'get',
    });
  };

  const resourcesControllerFindMeV1 = () => {
    return customAxios<ResourceDto>({ url: `/api/v1/resources/me`, method: 'get' });
  };

  const resourcesControllerFindOneV1 = (id: string) => {
    return customAxios<ResourceDto>({ url: `/api/v1/resources/${id}`, method: 'get' });
  };

  const resourcesControllerUpdateV1 = (
    id: string,
    createUpdateResourceRequest: CreateUpdateResourceRequest
  ) => {
    return customAxios<ResourceDto>({
      url: `/api/v1/resources/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateResourceRequest,
    });
  };

  const resourcesControllerDeleteV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/resources/${id}`, method: 'delete' });
  };

  const resourcesControllerReactivateV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/resources/${id}/reactivate`, method: 'post' });
  };

  const resourcesControllerAddLanguageV1 = (
    id: string,
    addLanguagesRequest: AddLanguagesRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/resources/${id}/languages`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: addLanguagesRequest,
    });
  };

  const resourcesControllerRemoveLanguageV1 = (id: string, languageId: string) => {
    return customAxios<void>({
      url: `/api/v1/resources/${id}/languages/${languageId}`,
      method: 'delete',
    });
  };

  const resourcesControllerSetMyLocationsV1 = (setLocationsRequest: SetLocationsRequest) => {
    return customAxios<void>({
      url: `/api/v1/resources/me/locations`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: setLocationsRequest,
    });
  };

  const resourcesControllerGetLocationsV1 = (id: string) => {
    return customAxios<LocationDto[]>({ url: `/api/v1/resources/${id}/locations`, method: 'get' });
  };

  const resourcesControllerSetLocationsV1 = (
    id: string,
    setLocationsRequest: SetLocationsRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/resources/${id}/locations`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: setLocationsRequest,
    });
  };

  const resourceDocumentsControllerFindAllV1 = (resourceId: string) => {
    return customAxios<ResourceDocumentDto[]>({
      url: `/api/v1/resource-documents/${resourceId}`,
      method: 'get',
    });
  };

  const resourceDocumentsControllerCreateV1 = (
    resourceId: string,
    createResourceDocumentDto: CreateResourceDocumentDto
  ) => {
    const formData = new FormData();
    formData.append('file', createResourceDocumentDto.file);
    formData.append('fileName', createResourceDocumentDto.fileName);

    return customAxios<void>({
      url: `/api/v1/resource-documents/${resourceId}`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  const resourceDocumentsControllerDeleteV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/resource-documents/${id}`, method: 'delete' });
  };

  const resourcesBatchControllerCreateV1 = (resourceBatchRequest: ResourceBatchRequest) => {
    return customAxios<void>({
      url: `/api/v1/resources-batch`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: resourceBatchRequest,
    });
  };

  const languagesControllerFindAllV1 = (params: LanguagesControllerFindAllV1Params) => {
    return customAxios<LanguageDto[]>({ url: `/api/v1/languages`, method: 'get', params });
  };

  const languagesControllerCreateV1 = (
    createUpdateLanguageRequest: CreateUpdateLanguageRequest
  ) => {
    return customAxios<LanguageDto>({
      url: `/api/v1/languages`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateLanguageRequest,
    });
  };

  const languagesControllerFindOneV1 = (id: string) => {
    return customAxios<LanguageDto>({ url: `/api/v1/languages/${id}`, method: 'get' });
  };

  const languagesControllerUpdateV1 = (
    id: string,
    createUpdateLanguageRequest: CreateUpdateLanguageRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/languages/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateLanguageRequest,
    });
  };

  const languagesControllerDeleteV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/languages/${id}`, method: 'delete' });
  };

  const languagesControllerReactivateV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/languages/${id}/reactivate`, method: 'post' });
  };

  const locationsControllerFindAllV1 = () => {
    return customAxios<LocationDto[]>({ url: `/api/v1/locations`, method: 'get' });
  };

  const locationsControllerCreateV1 = (
    createUpdateLocationRequest: CreateUpdateLocationRequest
  ) => {
    return customAxios<LocationDto>({
      url: `/api/v1/locations`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateLocationRequest,
    });
  };

  const locationsControllerFindOneV1 = (id: string) => {
    return customAxios<LocationDto>({ url: `/api/v1/locations/${id}`, method: 'get' });
  };

  const locationsControllerUpdateV1 = (
    id: string,
    createUpdateLocationRequest: CreateUpdateLocationRequest
  ) => {
    return customAxios<LocationDto>({
      url: `/api/v1/locations/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateLocationRequest,
    });
  };

  const locationsControllerDeleteV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/locations/${id}`, method: 'delete' });
  };

  const serviceBookingsControllerCreateV1 = (
    createServiceBookingRequest: CreateServiceBookingRequest
  ) => {
    const formData = new FormData();
    if (createServiceBookingRequest.file !== undefined) {
      formData.append('file', createServiceBookingRequest.file);
    }
    formData.append('date', createServiceBookingRequest.date);
    formData.append('customerId', createServiceBookingRequest.customerId);
    if (createServiceBookingRequest.debtorId !== undefined) {
      formData.append('debtorId', createServiceBookingRequest.debtorId);
    }
    formData.append('languageId', createServiceBookingRequest.languageId);
    if (createServiceBookingRequest.alternativeLanguageId !== undefined) {
      formData.append('alternativeLanguageId', createServiceBookingRequest.alternativeLanguageId);
    }
    formData.append('contactPerson', JSON.stringify(createServiceBookingRequest.contactPerson));
    formData.append('type', createServiceBookingRequest.type);
    if (createServiceBookingRequest.onsite !== undefined) {
      formData.append('onsite', JSON.stringify(createServiceBookingRequest.onsite));
    }
    if (createServiceBookingRequest.phone !== undefined) {
      formData.append('phone', JSON.stringify(createServiceBookingRequest.phone));
    }
    if (createServiceBookingRequest.remote !== undefined) {
      formData.append('remote', JSON.stringify(createServiceBookingRequest.remote));
    }
    if (createServiceBookingRequest.document !== undefined) {
      formData.append('document', JSON.stringify(createServiceBookingRequest.document));
    }
    if (createServiceBookingRequest.client !== undefined) {
      formData.append('client', JSON.stringify(createServiceBookingRequest.client));
    }
    if (createServiceBookingRequest.gender !== undefined) {
      formData.append('gender', createServiceBookingRequest.gender);
    }
    if (createServiceBookingRequest.acceptAlternativeResource !== undefined) {
      formData.append(
        'acceptAlternativeResource',
        createServiceBookingRequest.acceptAlternativeResource.toString()
      );
    }
    if (createServiceBookingRequest.specialRate !== undefined) {
      formData.append('specialRate', createServiceBookingRequest.specialRate.toString());
    }
    if (createServiceBookingRequest.notes !== undefined) {
      formData.append('notes', createServiceBookingRequest.notes);
    }

    return customAxios<ServiceBookingDto>({
      url: `/api/v1/service-bookings`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  const serviceBookingsControllerFindAllV1 = (params: ServiceBookingsControllerFindAllV1Params) => {
    return customAxios<ServiceBookingGroupDto[]>({
      url: `/api/v1/service-bookings`,
      method: 'get',
      params,
    });
  };

  const serviceBookingsControllerFindOneV1 = (id: string) => {
    return customAxios<ServiceBookingDto>({ url: `/api/v1/service-bookings/${id}`, method: 'get' });
  };

  const serviceBookingsControllerUpdateV1 = (
    id: string,
    updateServiceBookingRequest: UpdateServiceBookingRequest
  ) => {
    const formData = new FormData();
    if (updateServiceBookingRequest.file !== undefined) {
      formData.append('file', updateServiceBookingRequest.file);
    }
    if (updateServiceBookingRequest.resourceId !== undefined) {
      formData.append('resourceId', updateServiceBookingRequest.resourceId);
    }
    if (updateServiceBookingRequest.document !== undefined) {
      formData.append('document', JSON.stringify(updateServiceBookingRequest.document));
    }
    if (updateServiceBookingRequest.ignoreAvailability !== undefined) {
      formData.append(
        'ignoreAvailability',
        updateServiceBookingRequest.ignoreAvailability.toString()
      );
    }
    formData.append('date', updateServiceBookingRequest.date);
    formData.append('customerId', updateServiceBookingRequest.customerId);
    if (updateServiceBookingRequest.debtorId !== undefined) {
      formData.append('debtorId', updateServiceBookingRequest.debtorId);
    }
    formData.append('languageId', updateServiceBookingRequest.languageId);
    if (updateServiceBookingRequest.alternativeLanguageId !== undefined) {
      formData.append('alternativeLanguageId', updateServiceBookingRequest.alternativeLanguageId);
    }
    formData.append('contactPerson', JSON.stringify(updateServiceBookingRequest.contactPerson));
    formData.append('type', updateServiceBookingRequest.type);
    if (updateServiceBookingRequest.onsite !== undefined) {
      formData.append('onsite', JSON.stringify(updateServiceBookingRequest.onsite));
    }
    if (updateServiceBookingRequest.phone !== undefined) {
      formData.append('phone', JSON.stringify(updateServiceBookingRequest.phone));
    }
    if (updateServiceBookingRequest.remote !== undefined) {
      formData.append('remote', JSON.stringify(updateServiceBookingRequest.remote));
    }
    if (updateServiceBookingRequest.client !== undefined) {
      formData.append('client', JSON.stringify(updateServiceBookingRequest.client));
    }
    if (updateServiceBookingRequest.gender !== undefined) {
      formData.append('gender', updateServiceBookingRequest.gender);
    }
    if (updateServiceBookingRequest.acceptAlternativeResource !== undefined) {
      formData.append(
        'acceptAlternativeResource',
        updateServiceBookingRequest.acceptAlternativeResource.toString()
      );
    }
    if (updateServiceBookingRequest.specialRate !== undefined) {
      formData.append('specialRate', updateServiceBookingRequest.specialRate.toString());
    }
    if (updateServiceBookingRequest.notes !== undefined) {
      formData.append('notes', updateServiceBookingRequest.notes);
    }

    return customAxios<ServiceBookingDto>({
      url: `/api/v1/service-bookings/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  const serviceBookingsControllerUpdateVerificationV1 = (
    id: string,
    upsertVerificationRequest: UpsertVerificationRequest
  ) => {
    const formData = new FormData();
    if (upsertVerificationRequest.file !== undefined) {
      formData.append('file', upsertVerificationRequest.file);
    }
    formData.append('value', upsertVerificationRequest.value.toString());
    formData.append('issuer', upsertVerificationRequest.issuer);
    formData.append('autoVerify', upsertVerificationRequest.autoVerify.toString());
    if (upsertVerificationRequest.startTime !== undefined) {
      formData.append('startTime', upsertVerificationRequest.startTime);
    }

    return customAxios<void>({
      url: `/api/v1/service-bookings/${id}/verification`,
      method: 'patch',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  const serviceBookingsControllerUpdateCustomerSurchargesV1 = (
    id: string,
    updateSurchargeRequest: UpdateSurchargeRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/service-bookings/${id}/customer-surcharges`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateSurchargeRequest,
    });
  };

  const serviceBookingsControllerUpdateResourceSurchargesV1 = (
    id: string,
    updateSurchargeRequest: UpdateSurchargeRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/service-bookings/${id}/resource-surcharges`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateSurchargeRequest,
    });
  };

  const serviceBookingsControllerCancelV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/service-bookings/${id}/cancel`, method: 'put' });
  };

  const serviceBookingsControllerPublishV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/service-bookings/${id}/publish`, method: 'put' });
  };

  const serviceBookingsControllerTransformV1 = (
    id: string,
    transformBookingRequest: TransformBookingRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/service-bookings/${id}/transform`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: transformBookingRequest,
    });
  };

  const resourceBookingsControllerFindJobsV1 = () => {
    return customAxios<ResourceJobDto[]>({ url: `/api/v1/resource-bookings/jobs`, method: 'get' });
  };

  const resourceBookingsControllerFindJobByIdV1 = (id: string) => {
    return customAxios<ResourceJobDto>({
      url: `/api/v1/resource-bookings/jobs/${id}`,
      method: 'get',
    });
  };

  const resourceBookingsControllerFindRequestsV1 = () => {
    return customAxios<ResourceJobDto[]>({
      url: `/api/v1/resource-bookings/requests`,
      method: 'get',
    });
  };

  const resourceBookingsControllerFindRequestByIdV1 = (id: string) => {
    return customAxios<ResourceJobDto>({
      url: `/api/v1/resource-bookings/requests/${id}`,
      method: 'get',
    });
  };

  const resourceBookingsControllerFindBookingsV1 = (
    params: ResourceBookingsControllerFindBookingsV1Params
  ) => {
    return customAxios<ResourceServiceBookingDto[]>({
      url: `/api/v1/resource-bookings/bookings`,
      method: 'get',
      params,
    });
  };

  const resourceBookingsControllerFindBookingIdV1 = (id: string) => {
    return customAxios<ResourceServiceBookingDto>({
      url: `/api/v1/resource-bookings/bookings/${id}`,
      method: 'get',
    });
  };

  const resourceBookingsControllerAcceptRequestedServiceBookingV1 = (id: string) => {
    return customAxios<void>({
      url: `/api/v1/resource-bookings/requests/${id}/accept`,
      method: 'put',
    });
  };

  const resourceBookingsControllerDeclineRequestedServiceBookingV1 = (id: string) => {
    return customAxios<void>({
      url: `/api/v1/resource-bookings/requests/${id}/decline`,
      method: 'put',
    });
  };

  const resourceBookingsControllerAcceptPublishedServiceBookingV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/resource-bookings/jobs/${id}/accept`, method: 'put' });
  };

  const resourceBookingsControllerCloseV1 = (
    id: string,
    closeBookingRequest: CloseBookingRequest
  ) => {
    const formData = new FormData();
    if (closeBookingRequest.file !== undefined) {
      formData.append('file', closeBookingRequest.file);
    }
    formData.append('value', closeBookingRequest.value.toString());
    if (closeBookingRequest.startTime !== undefined) {
      formData.append('startTime', closeBookingRequest.startTime);
    }

    return customAxios<void>({
      url: `/api/v1/resource-bookings/bookings/${id}/close`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };

  const resourceBookingsControllerGetCancellationFeesV1 = (id: string) => {
    return customAxios<SurchargeDto>({
      url: `/api/v1/resource-bookings/bookings/${id}/cancel`,
      method: 'get',
    });
  };

  const resourceBookingsControllerConfirmCancelV1 = (id: string) => {
    return customAxios<void>({
      url: `/api/v1/resource-bookings/bookings/${id}/cancel`,
      method: 'post',
    });
  };

  const resourceBookingsControllerGetBillableBookingsV1 = (
    id: string,
    params: ResourceBookingsControllerGetBillableBookingsV1Params
  ) => {
    return customAxios<ResourceBillableDto>({
      url: `/api/v1/resource-bookings/resource/${id}/billable`,
      method: 'get',
      params,
    });
  };

  const resourceBookingsControllerGetBillableBookingsExportV1 = (
    id: string,
    params: ResourceBookingsControllerGetBillableBookingsExportV1Params
  ) => {
    return customAxios<Blob>({
      url: `/api/v1/resource-bookings/resource/${id}/billable/export`,
      method: 'get',
      params,
      responseType: 'blob',
    });
  };

  const resourceBookingsControllerUpdateCancellationFeeV1 = (
    id: string,
    feeId: string,
    updateCancellationFeeDto: UpdateCancellationFeeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/resource-bookings/resource/${id}/cancellation-fee/${feeId}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: updateCancellationFeeDto,
    });
  };

  const customersControllerCreateV1 = (registerCustomerRequest: RegisterCustomerRequest) => {
    return customAxios<CustomerDto>({
      url: `/api/v1/customers`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: registerCustomerRequest,
    });
  };

  const customersControllerFindAllV1 = () => {
    return customAxios<CustomerDto[]>({ url: `/api/v1/customers`, method: 'get' });
  };

  const customersControllerFindAllWithPaginationV1 = (
    params?: CustomersControllerFindAllWithPaginationV1Params
  ) => {
    return customAxios<CustomersControllerFindAllWithPaginationV1200>({
      url: `/api/v1/customers/paginated`,
      method: 'get',
      params,
    });
  };

  const customersControllerFindOneV1 = (id: string) => {
    return customAxios<CustomerDto>({ url: `/api/v1/customers/${id}`, method: 'get' });
  };

  const customersControllerUpdateV1 = (
    id: string,
    updateCustomerRequest: UpdateCustomerRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/customers/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: updateCustomerRequest,
    });
  };

  const customersControllerFindCustomerBookingsV1 = (
    id: string,
    params?: CustomersControllerFindCustomerBookingsV1Params
  ) => {
    return customAxios<CustomersControllerFindCustomerBookingsV1200>({
      url: `/api/v1/customers/${id}/bookings`,
      method: 'get',
      params,
    });
  };

  const customersControllerDownloadCustomerBookingsV1 = (
    id: string,
    params: CustomersControllerDownloadCustomerBookingsV1Params
  ) => {
    return customAxios<Blob>({
      url: `/api/v1/customers/${id}/bookings/export`,
      method: 'get',
      params,
      responseType: 'blob',
    });
  };

  const customersControllerAddBlockedResourceV1 = (
    id: string,
    addBlockedResourceRequest: AddBlockedResourceRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/customers/${id}/blocked-resources`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: addBlockedResourceRequest,
    });
  };

  const customersControllerRemoveBlockedResourceV1 = (id: string, resourceId: string) => {
    return customAxios<void>({
      url: `/api/v1/customers/${id}/blocked-resources/${resourceId}`,
      method: 'delete',
    });
  };

  const settingsControllerFindAllV1 = () => {
    return customAxios<SettingsDto>({ url: `/api/v1/settings`, method: 'get' });
  };

  const settingsControllerUpsertServiceRateV1 = (
    upsertServiceRateReqeuest: UpsertServiceRateReqeuest
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/service-rates`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: upsertServiceRateReqeuest,
    });
  };

  const settingsControllerCreateDateTimeSurchargeV1 = (
    createUpdateDateTimeSurchargeDto: CreateUpdateDateTimeSurchargeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/date-time-surcharges`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateDateTimeSurchargeDto,
    });
  };

  const settingsControllerUpdateDateTimeSurchargeV1 = (
    id: string,
    createUpdateDateTimeSurchargeDto: CreateUpdateDateTimeSurchargeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/date-time-surcharges/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateDateTimeSurchargeDto,
    });
  };

  const settingsControllerDeleteDayDateSurchargeV1 = (id: string) => {
    return customAxios<void>({
      url: `/api/v1/settings/date-time-surcharges/${id}`,
      method: 'delete',
    });
  };

  const settingsControllerCreateExpressSurchargeV1 = (
    createUpdateExpressSurchargeDto: CreateUpdateExpressSurchargeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/express-surcharges`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateExpressSurchargeDto,
    });
  };

  const settingsControllerUpdateExpressSurchargeV1 = (
    id: string,
    createUpdateExpressSurchargeDto: CreateUpdateExpressSurchargeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/express-surcharges/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateExpressSurchargeDto,
    });
  };

  const settingsControllerDeleteExpressSurchargeV1 = (id: string) => {
    return customAxios<void>({
      url: `/api/v1/settings/express-surcharges/${id}`,
      method: 'delete',
    });
  };

  const settingsControllerCreateTravelSurchargeV1 = (
    createUpdateTravelSurchargeDto: CreateUpdateTravelSurchargeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/travel-surcharges`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateTravelSurchargeDto,
    });
  };

  const settingsControllerUpdateTravelSurchargeV1 = (
    id: string,
    createUpdateTravelSurchargeDto: CreateUpdateTravelSurchargeDto
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/travel-surcharges/${id}`,
      method: 'patch',
      headers: { 'Content-Type': 'application/json' },
      data: createUpdateTravelSurchargeDto,
    });
  };

  const settingsControllerDeleteTravelSurchargeV1 = (id: string) => {
    return customAxios<void>({ url: `/api/v1/settings/travel-surcharges/${id}`, method: 'delete' });
  };

  const settingsControllerUpsertOpeningHoursV1 = (
    upsertOpeningHoursRequest: UpsertOpeningHoursRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/settings/opening-hours`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: upsertOpeningHoursRequest,
    });
  };

  const lexofficeControllerUpsertContactV1 = (lexofficeEvent: LexofficeEvent) => {
    return customAxios<void>({
      url: `/api/v1/lexoffice/webhook/contacts`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: lexofficeEvent,
    });
  };

  const lexofficeControllerUpdateInvoiceStatusV1 = (lexofficeEvent: LexofficeEvent) => {
    return customAxios<void>({
      url: `/api/v1/lexoffice/webhook/invoice-status`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: lexofficeEvent,
    });
  };

  const invoiceControllerGetInvoicesV1 = (params: InvoiceControllerGetInvoicesV1Params) => {
    return customAxios<InvoiceDto[]>({ url: `/api/v1/invoices`, method: 'get', params });
  };

  const invoiceControllerCreateInvoiceV1 = (creatInvoiceRequest: CreatInvoiceRequest) => {
    return customAxios<void>({
      url: `/api/v1/invoices`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: creatInvoiceRequest,
    });
  };

  const invoiceControllerGetChargeableServiceBookingsByCustomerV1 = (
    params: InvoiceControllerGetChargeableServiceBookingsByCustomerV1Params
  ) => {
    return customAxios<ChargeableServiceBookingsDto>({
      url: `/api/v1/invoices/chargeable`,
      method: 'get',
      params,
    });
  };

  const mailsControllerSendCustomerCancellationLinkV1 = (bookingId: string) => {
    return customAxios<void>({
      url: `/api/v1/mails/customer-cancellation/${bookingId}`,
      method: 'get',
    });
  };

  const mailsControllerSendServiceBookingSummaryV1 = (
    serviceBookingId: string,
    sendServiceBookingSummaryMailRequest: SendServiceBookingSummaryMailRequest
  ) => {
    return customAxios<void>({
      url: `/api/v1/mails/service-booking/${serviceBookingId}/summary`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: sendServiceBookingSummaryMailRequest,
    });
  };

  const reportsControllerGetRequestReportV1 = (
    params: ReportsControllerGetRequestReportV1Params
  ) => {
    return customAxios<CustomerRequestsReportDto>({
      url: `/api/v1/reports/requests`,
      method: 'get',
      params,
    });
  };

  const reportsControllerGetBookingReportV1 = (
    params: ReportsControllerGetBookingReportV1Params
  ) => {
    return customAxios<BookingStatusCountsResponseDto>({
      url: `/api/v1/reports/bookings`,
      method: 'get',
      params,
    });
  };

  const reportsControllerGetBookingReportExcelV1 = (
    params: ReportsControllerGetBookingReportExcelV1Params
  ) => {
    return customAxios<string>({ url: `/api/v1/reports/bookings/export`, method: 'get', params });
  };

  const hereControllerAutocompleteV1 = (params: HereControllerAutocompleteV1Params) => {
    return customAxios<HereAutocompleteResponse>({
      url: `/api/v1/here/address/autocomplete`,
      method: 'get',
      params,
    });
  };

  return {
    usersControllerFindMeV1,
    usersControllerUpdateMeV1,
    usersControllerFindOneV1,
    usersControllerDeleteV1,
    usersControllerUpdateV1,
    usersControllerFindAllV1,
    usersControllerCreateV1,
    resourcesControllerFindAllV1,
    resourcesControllerCreateV1,
    resourcesControllerGetFilterOptionsV1,
    resourcesControllerFindMeV1,
    resourcesControllerFindOneV1,
    resourcesControllerUpdateV1,
    resourcesControllerDeleteV1,
    resourcesControllerReactivateV1,
    resourcesControllerAddLanguageV1,
    resourcesControllerRemoveLanguageV1,
    resourcesControllerSetMyLocationsV1,
    resourcesControllerGetLocationsV1,
    resourcesControllerSetLocationsV1,
    resourceDocumentsControllerFindAllV1,
    resourceDocumentsControllerCreateV1,
    resourceDocumentsControllerDeleteV1,
    resourcesBatchControllerCreateV1,
    languagesControllerFindAllV1,
    languagesControllerCreateV1,
    languagesControllerFindOneV1,
    languagesControllerUpdateV1,
    languagesControllerDeleteV1,
    languagesControllerReactivateV1,
    locationsControllerFindAllV1,
    locationsControllerCreateV1,
    locationsControllerFindOneV1,
    locationsControllerUpdateV1,
    locationsControllerDeleteV1,
    serviceBookingsControllerCreateV1,
    serviceBookingsControllerFindAllV1,
    serviceBookingsControllerFindOneV1,
    serviceBookingsControllerUpdateV1,
    serviceBookingsControllerUpdateVerificationV1,
    serviceBookingsControllerUpdateCustomerSurchargesV1,
    serviceBookingsControllerUpdateResourceSurchargesV1,
    serviceBookingsControllerCancelV1,
    serviceBookingsControllerPublishV1,
    serviceBookingsControllerTransformV1,
    resourceBookingsControllerFindJobsV1,
    resourceBookingsControllerFindJobByIdV1,
    resourceBookingsControllerFindRequestsV1,
    resourceBookingsControllerFindRequestByIdV1,
    resourceBookingsControllerFindBookingsV1,
    resourceBookingsControllerFindBookingIdV1,
    resourceBookingsControllerAcceptRequestedServiceBookingV1,
    resourceBookingsControllerDeclineRequestedServiceBookingV1,
    resourceBookingsControllerAcceptPublishedServiceBookingV1,
    resourceBookingsControllerCloseV1,
    resourceBookingsControllerGetCancellationFeesV1,
    resourceBookingsControllerConfirmCancelV1,
    resourceBookingsControllerGetBillableBookingsV1,
    resourceBookingsControllerGetBillableBookingsExportV1,
    resourceBookingsControllerUpdateCancellationFeeV1,
    customersControllerCreateV1,
    customersControllerFindAllV1,
    customersControllerFindAllWithPaginationV1,
    customersControllerFindOneV1,
    customersControllerUpdateV1,
    customersControllerFindCustomerBookingsV1,
    customersControllerDownloadCustomerBookingsV1,
    customersControllerAddBlockedResourceV1,
    customersControllerRemoveBlockedResourceV1,
    settingsControllerFindAllV1,
    settingsControllerUpsertServiceRateV1,
    settingsControllerCreateDateTimeSurchargeV1,
    settingsControllerUpdateDateTimeSurchargeV1,
    settingsControllerDeleteDayDateSurchargeV1,
    settingsControllerCreateExpressSurchargeV1,
    settingsControllerUpdateExpressSurchargeV1,
    settingsControllerDeleteExpressSurchargeV1,
    settingsControllerCreateTravelSurchargeV1,
    settingsControllerUpdateTravelSurchargeV1,
    settingsControllerDeleteTravelSurchargeV1,
    settingsControllerUpsertOpeningHoursV1,
    lexofficeControllerUpsertContactV1,
    lexofficeControllerUpdateInvoiceStatusV1,
    invoiceControllerGetInvoicesV1,
    invoiceControllerCreateInvoiceV1,
    invoiceControllerGetChargeableServiceBookingsByCustomerV1,
    mailsControllerSendCustomerCancellationLinkV1,
    mailsControllerSendServiceBookingSummaryV1,
    reportsControllerGetRequestReportV1,
    reportsControllerGetBookingReportV1,
    reportsControllerGetBookingReportExcelV1,
    hereControllerAutocompleteV1,
  };
};
export type UsersControllerFindMeV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerFindMeV1']>>
>;
export type UsersControllerUpdateMeV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerUpdateMeV1']>>
>;
export type UsersControllerFindOneV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerFindOneV1']>>
>;
export type UsersControllerDeleteV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerDeleteV1']>>
>;
export type UsersControllerUpdateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerUpdateV1']>>
>;
export type UsersControllerFindAllV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerFindAllV1']>>
>;
export type UsersControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['usersControllerCreateV1']>>
>;
export type ResourcesControllerFindAllV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerFindAllV1']>>
>;
export type ResourcesControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerCreateV1']>>
>;
export type ResourcesControllerGetFilterOptionsV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerGetFilterOptionsV1']>
  >
>;
export type ResourcesControllerFindMeV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerFindMeV1']>>
>;
export type ResourcesControllerFindOneV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerFindOneV1']>>
>;
export type ResourcesControllerUpdateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerUpdateV1']>>
>;
export type ResourcesControllerDeleteV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerDeleteV1']>>
>;
export type ResourcesControllerReactivateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerReactivateV1']>>
>;
export type ResourcesControllerAddLanguageV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerAddLanguageV1']>>
>;
export type ResourcesControllerRemoveLanguageV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerRemoveLanguageV1']>
  >
>;
export type ResourcesControllerSetMyLocationsV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerSetMyLocationsV1']>
  >
>;
export type ResourcesControllerGetLocationsV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerGetLocationsV1']>>
>;
export type ResourcesControllerSetLocationsV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesControllerSetLocationsV1']>>
>;
export type ResourceDocumentsControllerFindAllV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceDocumentsControllerFindAllV1']>
  >
>;
export type ResourceDocumentsControllerCreateV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceDocumentsControllerCreateV1']>
  >
>;
export type ResourceDocumentsControllerDeleteV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceDocumentsControllerDeleteV1']>
  >
>;
export type ResourcesBatchControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourcesBatchControllerCreateV1']>>
>;
export type LanguagesControllerFindAllV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['languagesControllerFindAllV1']>>
>;
export type LanguagesControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['languagesControllerCreateV1']>>
>;
export type LanguagesControllerFindOneV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['languagesControllerFindOneV1']>>
>;
export type LanguagesControllerUpdateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['languagesControllerUpdateV1']>>
>;
export type LanguagesControllerDeleteV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['languagesControllerDeleteV1']>>
>;
export type LanguagesControllerReactivateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['languagesControllerReactivateV1']>>
>;
export type LocationsControllerFindAllV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['locationsControllerFindAllV1']>>
>;
export type LocationsControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['locationsControllerCreateV1']>>
>;
export type LocationsControllerFindOneV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['locationsControllerFindOneV1']>>
>;
export type LocationsControllerUpdateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['locationsControllerUpdateV1']>>
>;
export type LocationsControllerDeleteV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['locationsControllerDeleteV1']>>
>;
export type ServiceBookingsControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerCreateV1']>>
>;
export type ServiceBookingsControllerFindAllV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerFindAllV1']>
  >
>;
export type ServiceBookingsControllerFindOneV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerFindOneV1']>
  >
>;
export type ServiceBookingsControllerUpdateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerUpdateV1']>>
>;
export type ServiceBookingsControllerUpdateVerificationV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerUpdateVerificationV1']
    >
  >
>;
export type ServiceBookingsControllerUpdateCustomerSurchargesV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['serviceBookingsControllerUpdateCustomerSurchargesV1']
    >
  >
>;
export type ServiceBookingsControllerUpdateResourceSurchargesV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['serviceBookingsControllerUpdateResourceSurchargesV1']
    >
  >
>;
export type ServiceBookingsControllerCancelV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerCancelV1']>>
>;
export type ServiceBookingsControllerPublishV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerPublishV1']>
  >
>;
export type ServiceBookingsControllerTransformV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['serviceBookingsControllerTransformV1']>
  >
>;
export type ResourceBookingsControllerFindJobsV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerFindJobsV1']>
  >
>;
export type ResourceBookingsControllerFindJobByIdV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerFindJobByIdV1']>
  >
>;
export type ResourceBookingsControllerFindRequestsV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerFindRequestsV1']>
  >
>;
export type ResourceBookingsControllerFindRequestByIdV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerFindRequestByIdV1']
    >
  >
>;
export type ResourceBookingsControllerFindBookingsV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerFindBookingsV1']>
  >
>;
export type ResourceBookingsControllerFindBookingIdV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerFindBookingIdV1']
    >
  >
>;
export type ResourceBookingsControllerAcceptRequestedServiceBookingV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['resourceBookingsControllerAcceptRequestedServiceBookingV1']
    >
  >
>;
export type ResourceBookingsControllerDeclineRequestedServiceBookingV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['resourceBookingsControllerDeclineRequestedServiceBookingV1']
    >
  >
>;
export type ResourceBookingsControllerAcceptPublishedServiceBookingV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['resourceBookingsControllerAcceptPublishedServiceBookingV1']
    >
  >
>;
export type ResourceBookingsControllerCloseV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerCloseV1']>>
>;
export type ResourceBookingsControllerGetCancellationFeesV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerGetCancellationFeesV1']
    >
  >
>;
export type ResourceBookingsControllerConfirmCancelV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerConfirmCancelV1']
    >
  >
>;
export type ResourceBookingsControllerGetBillableBookingsV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerGetBillableBookingsV1']
    >
  >
>;
export type ResourceBookingsControllerGetBillableBookingsExportV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['resourceBookingsControllerGetBillableBookingsExportV1']
    >
  >
>;
export type ResourceBookingsControllerUpdateCancellationFeeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['resourceBookingsControllerUpdateCancellationFeeV1']
    >
  >
>;
export type CustomersControllerCreateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerCreateV1']>>
>;
export type CustomersControllerFindAllV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerFindAllV1']>>
>;
export type CustomersControllerFindAllWithPaginationV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerFindAllWithPaginationV1']
    >
  >
>;
export type CustomersControllerFindOneV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerFindOneV1']>>
>;
export type CustomersControllerUpdateV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerUpdateV1']>>
>;
export type CustomersControllerFindCustomerBookingsV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerFindCustomerBookingsV1']
    >
  >
>;
export type CustomersControllerDownloadCustomerBookingsV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerDownloadCustomerBookingsV1']
    >
  >
>;
export type CustomersControllerAddBlockedResourceV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerAddBlockedResourceV1']>
  >
>;
export type CustomersControllerRemoveBlockedResourceV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['customersControllerRemoveBlockedResourceV1']
    >
  >
>;
export type SettingsControllerFindAllV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerFindAllV1']>>
>;
export type SettingsControllerUpsertServiceRateV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerUpsertServiceRateV1']>
  >
>;
export type SettingsControllerCreateDateTimeSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerCreateDateTimeSurchargeV1']
    >
  >
>;
export type SettingsControllerUpdateDateTimeSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerUpdateDateTimeSurchargeV1']
    >
  >
>;
export type SettingsControllerDeleteDayDateSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerDeleteDayDateSurchargeV1']
    >
  >
>;
export type SettingsControllerCreateExpressSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerCreateExpressSurchargeV1']
    >
  >
>;
export type SettingsControllerUpdateExpressSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerUpdateExpressSurchargeV1']
    >
  >
>;
export type SettingsControllerDeleteExpressSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerDeleteExpressSurchargeV1']
    >
  >
>;
export type SettingsControllerCreateTravelSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerCreateTravelSurchargeV1']
    >
  >
>;
export type SettingsControllerUpdateTravelSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerUpdateTravelSurchargeV1']
    >
  >
>;
export type SettingsControllerDeleteTravelSurchargeV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerDeleteTravelSurchargeV1']
    >
  >
>;
export type SettingsControllerUpsertOpeningHoursV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['settingsControllerUpsertOpeningHoursV1']>
  >
>;
export type LexofficeControllerUpsertContactV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['lexofficeControllerUpsertContactV1']>
  >
>;
export type LexofficeControllerUpdateInvoiceStatusV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['lexofficeControllerUpdateInvoiceStatusV1']>
  >
>;
export type InvoiceControllerGetInvoicesV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['invoiceControllerGetInvoicesV1']>>
>;
export type InvoiceControllerCreateInvoiceV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['invoiceControllerCreateInvoiceV1']>>
>;
export type InvoiceControllerGetChargeableServiceBookingsByCustomerV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getSMPBackendAPIAdmin
      >['invoiceControllerGetChargeableServiceBookingsByCustomerV1']
    >
  >
>;
export type MailsControllerSendCustomerCancellationLinkV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['mailsControllerSendCustomerCancellationLinkV1']
    >
  >
>;
export type MailsControllerSendServiceBookingSummaryV1Result = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getSMPBackendAPIAdmin>['mailsControllerSendServiceBookingSummaryV1']
    >
  >
>;
export type ReportsControllerGetRequestReportV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['reportsControllerGetRequestReportV1']>
  >
>;
export type ReportsControllerGetBookingReportV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['reportsControllerGetBookingReportV1']>
  >
>;
export type ReportsControllerGetBookingReportExcelV1Result = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['reportsControllerGetBookingReportExcelV1']>
  >
>;
export type HereControllerAutocompleteV1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSMPBackendAPIAdmin>['hereControllerAutocompleteV1']>>
>;
